import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { FilterColumn, FilterEvent } from "src/app/models/filter";

@Component({
  selector: "app-card-filter",
  templateUrl: "./card-filter.component.html",
})
export class CardFilterComponent implements OnInit {
  public _filter = "";
  public showInactive = false;
  public _columnsToSearch: string[] = [];
  @Input() public columns: FilterColumn[] = [];
  @Input() public useActive: boolean = false;

  @Input() placeholder = "Buscar...";

  // TODO: rename onsearch to search. change alls templates
  @Output() onSearch = new EventEmitter<FilterEvent>();

  selectedFields: string[] = [];
  private searchSubject = new Subject<string>();

  ngOnInit() {
    this.selectedFields = this.columns.map((f) => f.property);

    this.searchSubject
      .pipe(debounceTime(400))
      .subscribe(() => this.emitFilter());
  }
  onSearchChange(value: string) {
    this._filter = value;
    this.searchSubject.next(value);
  }

  toggleField(field: string) {
    if (this.selectedFields.includes(field)) {
      this.selectedFields = this.selectedFields.filter((f) => f !== field);
    } else {
      this.selectedFields.push(field);
    }

    this.emitFilter();
  }

  toggleInactive() {
    this.showInactive = !this.showInactive;
    this.emitFilter();
  }

  clear() {
    this._filter = "";
    this.showInactive = false;
    this.selectedFields = this.columns.map((f) => f.property);

    this.emitFilter();
  }

  emitFilter() {
    this.onSearch.emit({
      filter: this._filter,
      columns: this.selectedFields,
      showInactive: this.showInactive,
    });
  }
}
